export function convertConfigToSnakeCase(config) {
    const newConfig = {};
    const usedKeys = ['parts', 'mine_color', 'printable_areas', 'engraving_areas'];

    Object.keys(config).map(key => {
        const newKey = key.replace(/([A-Z])/g, '_$1').toLowerCase();
        if (usedKeys.indexOf(newKey) > -1) {
            newConfig[newKey] = config[key];
        }
    });

    return newConfig;
}
